import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import React from 'react';
import { tldPromotionsApiClient } from './TldPromotionsWithPrice.apiClient';
import { Box, Heading, Text } from '@wix/design-system';
import s from '../common.scss';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { useIsMobile } from '@wix/core-domain-search';
export const getFallback = t => [{
  id: 'com-fallback',
  tld: 'com',
  description: t('domain_search_gate.tld_section.tld_fallback.com')
}, {
  id: 'net-fallback',
  tld: 'net',
  description: t('domain_search_gate.tld_section.tld_fallback.net')
}, {
  id: 'org-fallback',
  tld: 'org',
  description: t('domain_search_gate.tld_section.tld_fallback.org')
}, {
  id: 'store-fallback',
  tld: 'store',
  description: t('domain_search_gate.tld_section.tld_fallback.store')
}, {
  id: 'app-fallback',
  tld: 'app',
  description: t('domain_search_gate.tld_section.tld_fallback.app')
}, {
  id: 'co-fallback',
  tld: 'co',
  description: t('domain_search_gate.tld_section.tld_fallback.co')
}, {
  id: 'ai-fallback',
  tld: 'ai',
  description: t('domain_search_gate.tld_section.tld_fallback.ai')
}, {
  id: 'info-fallback',
  tld: 'info',
  description: t('domain_search_gate.tld_section.tld_fallback.info')
}];
const Base44ExtensionsBadge = () => {
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, t('domains_search_gate.base44.gate.extensions.badge'));
};
export const TldPromotionsWithPrice = _ref => {
  var _data$tldPromotionsWi;
  let _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'grid' : _ref$variant;
  const isMobile = useIsMobile();
  const isBase44 = variant === 'base44';
  const compact = isBase44 && isMobile;
  const titleKey = isBase44 ? 'domains_search_gate.base44.gate.extensions.title' : 'domain_search_gate.domain_gate.tld_section.header';
  const layout = isBase44 ? isMobile ? 'list' : 'grid' : variant;
  const _tldPromotionsApiClie = tldPromotionsApiClient.hooks.useTldPromotionsWithPrice({
      limit: 8
    }, true, {
      useErrorBoundary: false
    }),
    data = _tldPromotionsApiClie.data,
    isLoading = _tldPromotionsApiClie.isLoading,
    error = _tldPromotionsApiClie.error;
  const _DomainSearchGateModu2 = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu2.t;
  const promotions = error || !(data != null && (_data$tldPromotionsWi = data.tldPromotionsWithPrice) != null && _data$tldPromotionsWi.length) ? getFallback(t) : data == null ? void 0 : data.tldPromotionsWithPrice;
  const TldPromotionComponent = layout === 'list' ? DomainSearchSuiteModule.SDK.Components.TldPromotionsList : DomainSearchSuiteModule.SDK.Components.TldPromotions;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: isMobile ? '0px' : 'SP4',
    width: "100%",
    align: "center",
    padding: compact ? '0' : 'SP10 0 SP10 0'
  }, /*#__PURE__*/React.createElement(Box, {
    padding: compact ? '0 0 SP4 0' : isMobile ? 'SP4 0 4px 0' : 'SP4 0 SP3 0'
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "large",
    className: s.sectionTitle
  }, t(titleKey))), /*#__PURE__*/React.createElement(TldPromotionComponent, {
    isLoading: isLoading,
    promotions: promotions,
    compact: compact,
    Label: isBase44 ? Base44ExtensionsBadge : undefined
  }), /*#__PURE__*/React.createElement(Box, {
    paddingTop: compact ? 'SP2' : undefined
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin",
    secondary: true,
    light: true
  }, t('domain_search_gate.domain_gate.pricing_disclaimer'))));
};
//# sourceMappingURL=TldPromotionsWithPrice.js.map